import WithRender from "../../templates/containers/optionsContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getOptions"]),
    optionsType: () => {
      return "main";
    }
  },
  props: ["hideContainer"]
});
